import { __assign } from "tslib";
import React from 'react';
import Alert from '@material-ui/lab/Alert';
export var AlertSeverities;
(function (AlertSeverities) {
    // eslint-disable-next-line no-unused-vars
    AlertSeverities["ERROR"] = "error";
    // eslint-disable-next-line no-unused-vars
    AlertSeverities["WARNING"] = "warning";
    // eslint-disable-next-line no-unused-vars
    AlertSeverities["INFO"] = "info";
    // eslint-disable-next-line no-unused-vars
    AlertSeverities["SUCCESS"] = "success";
})(AlertSeverities || (AlertSeverities = {}));
/**
 * Alert.
 *
 * @param {AlertProps} props Alert's props
 * @returns {React.FC<AlertProps>} Alert.
 */
export var CustomAlert = function (options) { return (React.createElement(Alert, __assign({}, options.props, { severity: options.severity, className: options.className, "data-testid": options.testID }), options.children)); };
//# sourceMappingURL=Alert.js.map